export type WaktuSapaan = "pagi" | "sore" | "malam";

export interface SapaanWaktu {
  waktu: WaktuSapaan;
  label: string;
  icon: string;
}

export function sapaanWaktu(jam: number): SapaanWaktu {
  if (jam >= 6 && jam < 12) {
    return { waktu: "pagi", label: "Pagi", icon: "mdi-weather-sunset-up" };
  }

  if (jam >= 12 && jam < 18) {
    return { waktu: "sore", label: "Sore", icon: "mdi-white-balance-sunny" };
  }

  return { waktu: "malam", label: "Malam", icon: "mdi-weather-night" };
}
